import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr, LZe
 */
import { Utils } from '@logio/common-be-fe';
import * as React from 'react';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import translate from '../../../../i18n/translate';
import CheckBoxGroup from '../../../../inputs/CheckBoxGroup';
import Filter from './Filter';
import FilterWrapper from './FilterWrapper';
/**
 * Filter selecting number interval
 */

var AlertsFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(AlertsFilter, _Filter);

  function AlertsFilter() {
    var _this;

    _classCallCheck(this, AlertsFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlertsFilter).apply(this, arguments));
    _this.state = {
      valueType: ['with-value', 'blank']
    };
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

    _this.setModel = function (model) {
      return _this.setState({
        valueType: model ? model.valueType : ['with-value', 'blank']
      }, _this.props.filterChangedCallback);
    };

    _this.onCheckBoxGroupChange = function (valueType) {
      return _this.setState({
        valueType: valueType
      }, _this.props.filterChangedCallback);
    };
    /**
     * Resets input values and clears filter
     */


    _this.onClear = function () {
      return _this.setState({
        valueType: ['with-value', 'blank']
      }, _this.closePopup);
    };

    return _this;
  }
  /**
   * This function determines wheter column's filter is active
   */


  _createClass(AlertsFilter, [{
    key: "isFilterActive",
    value: function isFilterActive() {
      return this.state.valueType !== null && this.state.valueType !== undefined && this.state.valueType !== ['with-value', 'blank'];
    }
    /**
     * This function determines wheter each node passes the filter
     * In case of tree view this applies only from the lowest level
     * If there's a children matching filter, parent gets displayed even if it doesn't pass itself
     */

  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      if (this.state.valueType.includes('blank') && this.state.valueType.includes('with-value')) {
        return true;
      }

      var value = this.props.valueGetter(params.node);

      if (this.state.valueType.includes('with-value')) {
        return !Utils.isValueMissing(value) && value.resultObjects.size > 0;
      }

      if (this.state.valueType.includes('blank')) {
        return Utils.isValueMissing(value) || value.resultObjects.size === 0;
      }

      return false;
    }
    /**
     * This function is for getColumnState() output and similar
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return {
        valueType: this.state.valueType
      };
    }
    /**
     * Updates filter if value in floating filter changes
     * @param model object with filter state
     */

  }, {
    key: "onFloatingFilterChanged",
    value: function onFloatingFilterChanged(model) {
      if (!model) {
        this.setState({
          valueType: ['with-value', 'blank']
        }, this.props.filterChangedCallback);
      } else {
        this.setState({
          valueType: model.valueType
        }, this.props.filterChangedCallback);
      }
    }
    /**
     * Renders filter component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: true
      }, React.createElement(CheckBoxGroup, {
        values: this.state.valueType,
        name: "alert-checkboxgroup-filter",
        options: [{
          label: translate('filter-with-alerts'),
          value: 'with-value'
        }, {
          label: translate('filter-blank'),
          value: 'blank'
        }],
        onChange: this.onCheckBoxGroupChange
      })));
    }
  }]);

  return AlertsFilter;
}(Filter);

export { AlertsFilter as default };